import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/Checkout/index.tsx");
